import { Action, createReducer, on } from '@ngrx/store';
import { HttpError, Order } from '@rd/types';
import { IntentionalUndefined } from 'global-types';
import { UpdateDeliveryDetailsSuccess } from '../actions/delivery-details.actions';
import {
  CreateOrder,
  CreateOrderFail,
  CreateOrderSuccess,
  HydrateOrder,
} from '../actions/order-create.actions';

export interface CurrentOrderState {
  currentOrder: Order | null;
  error: HttpError | null;
  loading: boolean;
}

const initialState: CurrentOrderState = {
  currentOrder: null,
  error: null,
  loading: false,
};

export const currentOrderReducer: (
  state: CurrentOrderState | IntentionalUndefined,
  action: Action,
) => CurrentOrderState = createReducer(
  initialState,
  on(CreateOrder, (state: CurrentOrderState) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(CreateOrderFail, (state: CurrentOrderState, payload: HttpError) => {
    const { ...httpError } = payload;

    return {
      ...state,
      error: httpError,
      loading: false,
    };
  }),
  on(
    CreateOrderSuccess,
    (state: CurrentOrderState, payload: { order: Order }) => {
      const { order } = payload;

      return {
        ...state,
        currentOrder: order,
        loading: false,
      };
    },
  ),
  on(
    UpdateDeliveryDetailsSuccess,
    (state: CurrentOrderState, payload: { order: Order }) => {
      const { order } = payload;

      if (!state.currentOrder) {
        return state;
      }

      return {
        ...state,
        currentOrder: {
          ...state.currentOrder,
          data: {
            recipient: order.data.recipient,
          },
        },
      };
    },
  ),
  on(HydrateOrder, (state: CurrentOrderState, payload: { order: Order }) => {
    const { order } = payload;
    return {
      ...state,
      currentOrder: order,
    };
  }),
);
